import type { HostGameState, MatchmakeableBlockReason } from '@playcastdotio/Messaging';

export type JoinabilityAction = 'arm' | 'hold' | 'leave';

export interface JoinabilityInputs {
  matchmakeable: boolean;
  blockReason: MatchmakeableBlockReason | null;
  gameState: HostGameState; // 'idle' | 'prewarming' | 'ready' | 'active' | 'cooldown'
}

const HOLD_GAME_STATES: ReadonlySet<HostGameState> = new Set(['active', 'prewarming', 'cooldown']);

const HOLD_BLOCK_REASONS: ReadonlySet<MatchmakeableBlockReason> = new Set([
  'cooldown',
  'game_save_restore',
]);

/**
 * arm   — host is matchmakeable: keep/raise warm capture.
 * hold  — a player is in game or a restart for the next player is in flight:
 *         leave joinability untouched so capture is not released mid-cycle.
 * leave — host is out of the pool for a non-restart reason: release capture.
 */
export function decideJoinabilityAction(inputs: JoinabilityInputs): JoinabilityAction {
  if (inputs.matchmakeable) return 'arm';
  if (HOLD_GAME_STATES.has(inputs.gameState)) return 'hold';
  if (inputs.blockReason !== null && HOLD_BLOCK_REASONS.has(inputs.blockReason)) return 'hold';
  return 'leave';
}
